<template>
  <div class="right_block courses">
    <CourseCard v-if="isAuth && $route.name === 'course-info_id'" :course-info="courseInfo" :stages-list="stagesList" />

    <CoursesList v-if="userRole === 'leader'" :categories-list="categoriesList" />

    <UsersList :users-list="usersList" :total="totalUsers" @load="addUsers" />
  </div>
</template>

<script>
import UsersList from '@/components/right_block/UsersList'
import CoursesList from '@/components/right_block/CoursesList'
import CourseCard from '@/components/right_block/CourseCard'

export default {
  components: {
    UsersList,
    CoursesList,
    CourseCard
  },
  props: {
    courseInfo: {
      default: () => {},
      type: Object
    },
    stagesList: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      currentUsersPage: 1
    }
  },
  mounted() {
    this.loadUsers()
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    isAuth() {
      return this.$store.state.auth.auth
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    },
    totalUsers() {
      return this.$store.state.right.rightUsersList.total
    },
    usersList() {
      return this.$store.state.right.rightUsersList.users.filter((el) => !el.branch.deleted_at)
    }
  },
  methods: {
    addUsers() {
      if (this.currentUsersPage < this.totalUsers / 15) {
        this.currentUsersPage += 1
        this.loadUsers()
      }
    },
    loadUsers() {
      this.$axios2
        .get('users?page=' + this.currentUsersPage)
        .then((resp) => {
          this.$store.commit('setRightUsersList', { list: resp.data })
        })
        .catch(this.$errorToast)
    }
  }
}
</script>
